import { useListenUserProfileQuery } from 'modules/Users/userApi'

import { useListenMyCommunityProfileQuery } from './communityApi'
import { getUsablePicture } from './communityUtils'

// Author identity for anything the coach writes (posts and replies). Mirrors
// mobile's getMyAuthorInfo: prefer the coach's community profile (set up in the
// app), fall back to the dashboard account profile.
export default function useCoachAuthor({ coachOrgId, userId }) {
  const { data: communityProfileData } = useListenMyCommunityProfileQuery({ coachOrgId, userId })
  const communityProfile = communityProfileData?.isLoading ? null : communityProfileData
  const { data: userProfile } = useListenUserProfileQuery({ userId })
  const fallbackName = [userProfile?.firstname, userProfile?.lastname].filter(Boolean).join(' ')

  return {
    displayName: communityProfile?.displayName || fallbackName,
    picture: getUsablePicture(communityProfile?.picture) || getUsablePicture(userProfile?.picture),
    isCoach: true,
  }
}
